export const registerServiceWorker = () => {
  if (!('serviceWorker' in navigator)) {
    console.warn('Service Worker não suportado.');
    return;
  }

  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register(
        '/service-worker-vFINAL-1.js',
        { scope: '/' }
      );

      try {
        await registration.update?.();
      } catch {}

      console.log('Service Worker registrado:', registration);

      // Se já existe um SW esperando, ativa imediatamente
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }

      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed') {
            console.log('Nova versão instalada.');

            // Só faz swap imediato quando isso for UPDATE (não primeiro install)
            if (navigator.serviceWorker.controller) {
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          }
        });
      });

      // Anti-loop no iOS: recarrega no máximo 1x por aba
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        const key = 'sw-controllerchange-reloaded-once';
        if (sessionStorage.getItem(key)) return;

        sessionStorage.setItem(key, '1');
        console.log('Novo SW assumiu controle. Recarregando 1x...');
        window.location.reload();
      });
    } catch (error) {
      console.error('Erro ao registrar Service Worker:', error);
    }
  });
};